import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectBox } from 'cbc-shared-lib';
import { CodeConversionMstDto } from 'sg-api';

/** 表示項目 */
export const visibletarget = {
  DISABLED: '0',
  ANOTHERUSER: '1',
  EXCIS: '2'
} as const;

export type visibleTget = typeof visibletarget[keyof typeof visibletarget];

/**
 * 振替登録画面_振替登録
 * @export
 * @class Sgke040dSearchConditionComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'app-sgke040d-search-condition',
  templateUrl: './sgke040d-search-condition.component.html',
  styleUrl: './sgke040d-search-condition.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgke040dSearchConditionComponent implements OnInit, OnDestroy, OnChanges {
  // コードマスタ取得
  @Input() codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;

  /** 選択状態切替エミッター */
  @Output() hideEvent = new EventEmitter();
  /** 振替先検索ボタン押下エミッター */
  @Output() searchEmit = new EventEmitter();
  /** 登録ボタン（CIS外）押下エミッター */
  @Output() registNonCisEmit = new EventEmitter();

  /** 親コンポーネント保持領域 */
  parentForm: UntypedFormGroup;
  /** 請求お客さま番号 */
  recptFixNo: UntypedFormControl = new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(/^[0-9]+$/)]);
  /** 請求状況一覧情報FormGroup */
  recptJokyInfForm: UntypedFormGroup;
  /** 振替区分 */
  public furikaeDiv: UntypedFormControl = this.fb.control({ value: '', disabled: false }, [Validators.required]);
  /** 表示条件*/
  visibleTarget?: visibleTget;

  /** 振替登録先 */
  furikaeList: SelectBox[] = [];

  /**
   * コンストラクタ
   * @param {FormGroupDirective} parent
   * @param {UntypedFormBuilder} fb
   * @memberof Sgke040dSearchConditionComponent
   */
  constructor(public parent: FormGroupDirective,
    private fb: UntypedFormBuilder) {
  }

  /**
   * 初期処理
   * @memberof Sgke040dSearchConditionComponent
   */
  ngOnInit(): void {
    // FormGroupを作成
    this.recptJokyInfForm = this.fb.group({
      recptFixNo: this.recptFixNo,
      claimPayFlgSearch: "0",
      furikaeDiv: this.furikaeDiv
    });

    // 親FormGroupに本コンポーネントのForm情報を追加
    if (this.parent.form != null) {
      this.parentForm = this.parent.form;
      this.parentForm.addControl('recptJokyInfLstDto', this.recptJokyInfForm);
    }
  }

  /**
   * @Inputプロパティが変更されたときに、その変更に関する情報を提供します。
   * @param {SimpleChanges} changes
   * @memberof Sgke040dSearchConditionComponent
   */
  ngOnChanges(changes: SimpleChanges) {
    // 対象プロパティが変更された場合のみ処理する
    if (changes.codeConversionMstMap && this.codeConversionMstMap) {
      // コード値毎のkeyに対して、userCode(セレクトボックスの値)、hyojiCont(セレクトボックスの表示文字)がサービスから設定されているので、それを取得する
      // コードS300980 のリスト取得
      this.furikaeList.push(...this.getSelectBoxFromCodeConversionMst('S300980'));
    }
  }

  /**
   * 終了処理
   * @memberof Sgke040dSearchConditionComponent
   */
  ngOnDestroy(): void {
    this.parentForm.clearValidators();
    this.parentForm.updateValueAndValidity();
    this.parentForm.removeControl('recptJokyInfLstDto');
  }

  /**
  * コードIDに対応するコード変換マスタ値をSelectBoxの配列で戻す
   * @param {string} codeId
   * @return {*}  {SelectBox[]}
   * @memberof Sgke040dSearchConditionComponent
   */
  getSelectBoxFromCodeConversionMst(codeId: string): SelectBox[] {
    let retSelectBoxList: SelectBox[] = [];
    let codeList: CodeConversionMstDto[] = [];
    if (this.codeConversionMstMap.has(codeId)) {
      codeList = this.codeConversionMstMap.get(codeId);
      if (codeList) {
        codeList.forEach(data => {
          const select: SelectBox = { value: data.userCode, viewValue: data.hyojiCont };
          retSelectBoxList.push(select);
        })
      }
    }
    return retSelectBoxList;
  }

  /**
   * 振替登録先選択時処理
   * @param {*} value
   * @memberof Sgke040dSearchConditionComponent
   */
  changeList(value): void {
    this.visibleTarget = value;
    if (this.visibleTarget != '1') {
      this.hideEvent.emit()
    }
  }

  /**
   * 振替先検索ボタン押下時処理
   * @memberof Sgke040dSearchConditionComponent
   */
  onClickSearchFurikaesaki() {
    this.searchEmit.emit(this.recptFixNo.value);
  }

  /**
   * 登録ボタン（CIS外）押下時処理
   * @memberof Sgke040dSearchConditionComponent
   */
  onClickRegistNonCis() {
    this.registNonCisEmit.emit();
  }

}